import useSlugExtractor from "@hooks/useSlugExtractor"

import { AccessCheck } from "@particles"

import { NavTopBar } from "@organisms"

import { AppFrame } from "@templates"

import { VENDOR_ROUTES } from "@routes/vendor"

import { objectMap } from "@constants/objectMap"
import { PERMISSION_LEVEL } from "@constants/permissionLevel"

import VendorTableView from "./views/VendorTableView/VendorTableView"

export default function VendorList() {
    const [createRoute] = useSlugExtractor([VENDOR_ROUTES.CREATE])

    return (
        <AppFrame.Root collaborationRoomName="vendor-list">
            <NavTopBar.Root>
                <NavTopBar.Header>
                    <NavTopBar.NavTopBarHeaderStart>
                        <NavTopBar.PageTitle label={objectMap.vendor.labelPlural} icon={objectMap.vendor.iconActive} />
                    </NavTopBar.NavTopBarHeaderStart>
                    <NavTopBar.NavTopBarHeaderEnd>
                        <NavTopBar.PagePresence />
                        <AccessCheck
                            permissions={{
                                vendors_list_permission: PERMISSION_LEVEL.RESTRICTED,
                            }}
                        >
                            <AccessCheck
                                permissions={{
                                    vendors_view_permission: PERMISSION_LEVEL.FULL,
                                }}
                            >
                                <NavTopBar.SearchButton scope="Vendors" />
                            </AccessCheck>
                        </AccessCheck>
                        <AccessCheck
                            permissions={{
                                vendors_create_permission: PERMISSION_LEVEL.RESTRICTED,
                            }}
                        >
                            <NavTopBar.CTAButton destination={createRoute} />
                        </AccessCheck>
                    </NavTopBar.NavTopBarHeaderEnd>
                </NavTopBar.Header>
            </NavTopBar.Root>
            <VendorTableView />
        </AppFrame.Root>
    )
}
